import { FormSpy } from 'react-final-form';

import { lodashGet } from 'functions/lodashGet';

interface IFileButtonErrorMessageProps {
  name: string;
}

export const FileButtonErrorMessage = ({ name }: IFileButtonErrorMessageProps) => {
  return (
    <FormSpy subscription={{ errors: true, touched: true }}>
      {props => {
        const error = lodashGet(props.errors || {}, name);
        const isFieldTouched = props.touched?.[name];

        if (isFieldTouched && error) {
          return <p className={`shared-input-error shared-row__small-margin`}>{error}</p>;
        }

        return null;
      }}
    </FormSpy>
  );
};
